<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="trinka_cloud_banner_text">
                        <h1>Online Paraphraser</h1>
                        <h2>작문 실멱 및 명확성 향상</h2>
                        <p>작성자의 의도를 이해하여 글을 명확하고 일관적이며 문법적으로 맞게 글을 작성할 수 있도록 AI 기반에 의해 제안 합니다. </p>
                        <ul class="highted-points">
                            <li>패러프레이징된 택스트의 변형 조정</li>
                            <li>패러프레이징된 여러가지 옵션 중 선택 가능 </li>
                            <li>효율적인 구문 분석</li>
                        </ul>
                        <a href="https://cloud.trinka.ai/signup?_rg=GB" id="autoEditGetStart" target="_blank">시작(무료)</a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 no-gutter">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../../assets/images/paraphraser/online_paraphrase_banner.svg" alt="auto edit">
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="../../../../assets/images/online-phraphraser-video-banner.jpg" alt="online-phraphraser" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>작동 방식</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">■ 트링카(Trinka) 패러프레이징 툴 단계별 상세 사용 방법은 영상을 통해 확인하실 수 있습니다. </p>
                        <p>사용 관련 자주 묻는 질문 사항은 <a style="color: #0000ff;" (click)="scroll(target)" class="link">여기</a>를 통해 확인하실 수 있습니다. </p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="cloud_key_features keyFeatures">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>트링카 패러프레이즈의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카의 어드밴스 "패러프레이즈"와 빠르고 쉽게 "리프레이징" 할 수 있는 기능에 대해 알아보세요.</p>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md-6 col-lg-4">
                    <div class="feature-left">
                        <h3>스피드 업! 패러프레이징(Paraphrasing)</h3>
                        <p>패러프레이즈는 트링카의 기존 소프트웨어에 원활하게 통합되어  익숙한 사용자 인터페이스 내에서 사용할 수 있습니다.
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7 offset-lg-1">
                    <div class="feature-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="../../../../assets/images/paraphraser/videos/speed-up-paraphrase.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6 col-lg-4 offset-lg-1">
                    <div class="feature-left">
                        <h3>다양한 레벨로 조정</h3>
                        <p>트링카는 문구 수정의 변경 범위를  원하는 대로 조정하여 리프레싱 범위를 조정할 수 있습니다. 
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7">
                    <div class="feature-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="../../../../assets/images/paraphraser/videos/level-of-variation.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md-6 col-lg-4">
                    <div class="feature-left">
                        <h3>패러프레이즈된 다양한 대안 중 선택</h3>
                        <p>트랑카는 패러프레이즈된 텍스트를 다양하게 제공하여 일관성을 유지시킬 수 있도록 합니다.
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7 offset-lg-1">
                    <div class="feature-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="../../../../assets/images/paraphraser/videos/aternatives.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6 col-lg-4 offset-lg-1">
                    <div class="feature-left">
                        <h3>패러프레이징된 텍스트를 손쉽게 변경</h3>
                        <p>트링카(Trinka)를 통해 몇 번의 클릭만으로 원본 콘텐츠를 패러프레이징한 콘텐츠로 쉽게 변경 가능하며, 변경된 문서는 자동으로 삽입됩니다.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7">
                    <div class="feature-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="../../../../assets/images/paraphraser/videos/Replaced-Paraphrase.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
            <div class="row align-items-center match-box">
                <div class="col-md-6 col-lg-4">
                    <div class="feature-left">
                        <h3>변경사항 검토 및 완료</h3>
                        <p>패러프레이징된 텍스트를 보고 원본 텍스트의 변경 사항 추적으로 변경 내용을 식별할 수 있습니다.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7 offset-lg-1">
                    <div class="feature-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="../../../../assets/images/paraphraser/videos/show-revisions.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>트링카 (Trinka) 패러프레이즈를</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row match-box">

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c_card">
                        <span>
                            <img src="../../../../assets/images/paraphraser/icon1.svg" alt="icon">
                        </span>
                        <h3>효율성 향상</h3>
                        <p>에디터에 통합된 트링카 패러프레이즈로 시간은 절약하고 생산성은 향상시켜 단일 플랫폼 안에서 작업할 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c_card">
                        <span>
                            <img src="../../../../assets/images/paraphraser/icon2.svg" alt="icon">
                        </span>
                        <h3>효과적인 의역</h3>
                        <p>트링카 패러프레이즈를 통해 최종 결과물을 
                            완벽하게 제어할 수 있으므로 문구 수정의 
                            범위를 조정하고 여러 옵션 중 의도에 가장 
                            적합한  구문을 선택할 수 있습니다.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c_card">
                        <span>
                            <img src="../../../../assets/images/paraphraser/icon3.svg" alt="icon">
                        </span>
                        <h3>명확성 향상</h3>
                        <p>트링카 패러프레이즈로 구문 분석 하면서 명확성과 일관성을 향상시킬 수 있습니다. <br/>
                            또한 문법, 철자 및 구조에 문제가 있는지 
                            문장을 검토합니다.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>트링카 패러프레이즈 를 무제한으로 이용해 보세요.</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank">시작 </a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="aboutTrinkaCreditHeading">
                        <span>기업용</span>
                        <h2>트링카 패러프레이즈 API</h2>
                        <div class="HeadingSubLine"></div>
                        <p>그룹 워크플로우에 트링카의 의역 기능을 직접 통합해 콘텐츠의 명확성을 향상시켜 보세요..</p>
                        <ul>
                            <li>
                                <b>빠른 속도와 확장성</b> - 트링카의 빠른 의역 기능은 팀의 콘텐츠 생산성을 높이고 전반적인 생산성을 
                                향상시키는 데 도움이 됩니다. 조직의 증가하는 요구사항에 따라 쉽게 확장할 수 있습니다.
                            </li>
                            <li>
                                <b> 데이터 보안</b> - 모든 데이터는 고도로 암호화된 환경에 보관됩니다.<br/> 작업하는 텍스트의 양에 관계없이
                                 콘텐츠는 기밀로 유지됩니다.
                            </li>
                            <li>
                                <b>사용자 지정 가능</b> - 일관성을 유지하기 위해  패러프레이징 수준과 rephrase(리퍼레이즈) 옵션 수를 그룹 전체에 걸쳐 맞춤화할 수 있습니다. 따라서 명확성과 일관성을 쉽게 달성할 수 있습니다.

                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="api_img">
                        <img src="../../../../assets/images/paraphraser/API.svg" class="img-fluid" alt="api" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자주 묻는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        트링카 패러프레이즈는 무료 인가요?  </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>네, 트링카 패러프레이즈는 무료 입니다. 하지만 베이직 플랜은 문법 체크에 사용할 수 있는 5000단어 외에도 패러프레이징 할 수 있는 월 5000단어가 제한되어 있습니다.
                                        </p>
                                        <p>무제한 액세스를 원하시는 분들께는 프리미엄 요금제를 추천 합니다. 프리미엄 요금제는 사용자가 원하는 만큼 제한 없이 콘텐츠를 다양하게 표현할 수 있습니다. 지금 바로 업그레이드해 보세요!</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        패러프레이징 플랫폼 이용 시 내 콘텐츠는 안전한가요? </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>네, 트링카는 최고 수준의 데이터 보안  및 규정을 준수 하여 안심하고 사용하셔도 됩니다. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        패러프레이징 레벨을 사용자에 맞춰 지정할 수 있나요? 
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>네, 가능합니다. 문서 유형을 지정할 수 있으며, 문서 내용이 사용자의 기본 설정과 일치하는지 확인한 후 다양한 패러프레이즈의 옵션 중에서 선택할 수도 있습니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        패러프레이징 툴(paraphrasing tool)은 기술 문서 또는 전문적인 콘텐츠도 다룰 수 있나요? 
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        <p>트링카 패러프레이징 툴은 학술 및 기술 문서에 특화되어 있습니다. 패러프레이징 툴은 전문 콘텐츠의 정확성과 특수성을 유지하도록 맞춤화되어 있습니다.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/kr/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                            <h3>클라우드</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                            <h3>브라우저 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/qF_9Al4NHIY"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>